import { createDecorator } from 'vue-class-component'

export const Meta = createDecorator((options, key) => {
  const metaInfo = 'metaInfo'
  options[metaInfo] = options.methods[key]
})
